import React, { useEffect, useState, useRef } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Eye } from "lucide-react";
import DetailsView from "./DetailsView";
import Loader from "../../../../Utils/Loader";
import "react-datepicker/dist/react-datepicker.css";
import {
  getOpenPosition,
  updateTargetAndStoploss,
  SubadminOpenPosition
} from "../../../../Service/admin.service";
import { fDateTimeSuffix } from "../../../../Utils/Date_formet";
import DeltaSocketClient from "../../../../Utils/main/DeltaSocket";
import "react-datepicker/dist/react-datepicker.css";
import { TRADE_EXECUTE } from "../../../../Service/user.service";
import toast from "react-hot-toast";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
const Tradinghistory = (token) => {

  const today = format(new Date(), "yyyy-MM-dd");

  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"))
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [strategy, setStrategy] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [rowData, setRowData] = useState("");
  const [tradeHistoryData, setTradeHistoryData] = useState([]);
  const [filteredTradeData, setFilteredTradeData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [livePrices, setLivePrices] = useState({});
  const [symbolList, setSymbolList] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const [editableRows, setEditableRows] = useState({});
  const [tradeUpdates, setTradeUpdates] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [availableStrategies, setAvailableStrategies] = useState([]);
  const [quantityM, setQuantity] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsername, setSelectedUsername] = useState("");


  const roundSmart = (value) => {
    if (isNaN(value)) return null;
    value = Number(value);

    let digits;
    if (Math.abs(value) >= 1000) {
      digits = 2;
    } else if (Math.abs(value) >= 1) {
      digits = 2;
    } else if (Math.abs(value) >= 0.01) {
      digits = 4;
    } else {
      digits = 6;
    }

    return Number(value.toFixed(digits));
  };

  const extractStrategies = (data) => {
    const strategies = [
      ...new Set(data.map((item) => item.strategy).filter(Boolean)),
    ];
    return strategies.sort();
  };

  const filterTradeData = (data, selectedStrategy) => {
    if (!selectedStrategy) {
      return data;
    }
    return data.filter((trade) => trade.strategy === selectedStrategy);
  };

  const fetchTradeHistory = async () => {
    setLoading(true);
    try {
      const response = await SubadminOpenPosition({
        fromDate: fromDate,
        toDate: toDate,
        strategy: strategy,
        userid: isgotodashboard ? gotodashboard.user_id : user_details.user_id
      });
      if (response?.status) {
        const allData = response.data || [];
        setTradeHistoryData(allData);
        setAvailableStrategies(extractStrategies(allData));

        const filtered = filterTradeData(allData, strategy);
        setFilteredTradeData(filtered);

        setSymbolList([...new Set(filtered.map((trade) => trade.symbol))]);
      } else {
        setTradeHistoryData([]);
        setFilteredTradeData([]);
        setSymbolList([]);
      }
    } catch (err) {
      setTradeHistoryData([]);
      setFilteredTradeData([]);
      setSymbolList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const filtered = filterTradeData(tradeHistoryData, strategy);
    setFilteredTradeData(filtered);
    setSymbolList([...new Set(filtered.map((trade) => trade.symbol))]);
  }, [strategy, tradeHistoryData]);

  useEffect(() => {
    const filtered = tradeHistoryData.filter((trade) => {
      const matchStrategy = strategy ? trade.strategy === strategy : true;
      const matchSearch =
        trade.symbol?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        trade.strategy?.toLowerCase().includes(searchTerm.toLowerCase());
      const matchUser =
        selectedUsername
          ? trade.userInfo?.UserName === selectedUsername
          : true;

      return matchStrategy && matchSearch && matchUser;
    });

    setFilteredTradeData(filtered);
    setSymbolList([...new Set(filtered.map((trade) => trade.symbol))]);
  }, [strategy, tradeHistoryData, searchTerm, selectedUsername]);


  useEffect(() => {
    fetchTradeHistory();
  }, [fromDate, toDate, refresh, strategy]);

  useEffect(() => {
    const client = DeltaSocketClient.instance;
    if (!client) return;

    symbolList.forEach((s) => client.subscribe(s));

    symbolList.forEach((s) => {
      const cached = client.getPrice(s);
      if (cached) {
        setLivePrices((prev) => ({ ...prev, [s]: cached }));
      }
    });

    const handleUpdate = (data) => {
      if (data.symbol && data.spot_price) {
        setLivePrices((prev) => {
          const updated = { ...prev, [data.symbol]: data.spot_price };
          return updated;
        });
      }
    };

    const oldCallback = client.onMessageCallback;
    client.onMessageCallback = handleUpdate;

    return () => {
      client.onMessageCallback = oldCallback;
    };
  }, [symbolList]);

  const getFieldValue = (row, fieldName) => {
    return tradeUpdates[row._id]?.[fieldName] || row[fieldName] || "";
  };

  const getInputClassName = (row, fieldName) => {
    const errorKey = `${row._id}-${fieldName}`;
    return `form-control form-control-sm ${validationErrors[errorKey] ? "is-invalid" : ""
      }`;
  };

  const handleOnChange = (row, e) => {
    const { name, value } = e.target;
    if (!row._id) return;

    if (value < 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Negative values are not allowed!",
      });
      return;
    }

    setTradeUpdates((prev) => ({
      ...prev,
      [row._id]: { ...prev[row._id], [name]: value },
    }));
  };

  const handleUpdateRow = async (row) => {
    try {
      const target = tradeUpdates[row._id]?.target;
      const stoploss = tradeUpdates[row._id]?.stoploss;

      // Check: at least one should be filled
      if (!target && !stoploss) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please fill at least Target or Stoploss!",
        });
        return;
      }

      const payload = {
        tradeId: row._id,
        target,
        stoploss,
      };

      const response = await updateTargetAndStoploss(payload);

      if (response?.status) {
        toast.success(
          response.message || "Target & Stoploss updated successfully ✅"
        );

        fetchTradeHistory();
        setEditableRows((prev) => ({ ...prev, [row._id]: false }));
      } else {
        toast.error(response?.message || "Update failed ❌");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong ❌");
    }
  };

  const refresbtn = () => {
    setStrategy("");
  };

  const columns = [
    {
      name: "Signals Entry Time",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
      ),
      sortable: true,
      width: "230px",
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
      width: "120px",
    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "110px",
    },
    {
      name: "Entry Type",
      selector: (row) => row.side,
      cell: (row) =>
        row?.side === "BUY" ? (
          <span className="badge bg-success">BUY ENTRY</span>
        ) : (
          <span className="badge bg-danger">SELL ENTRY</span>
        ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Quantity",
      selector: (row) =>
        row.quantity !== null ? quantityM : "-",
      sortable: true,
      width: "120px",
    },
    {
      name: "Entry Price",
      selector: (row) =>
        row.entryPrice !== null ? parseFloat(row.entryPrice) : "-",
      sortable: true,
      width: "140px",
      cell: (row) =>
        row.entryPrice !== null ? roundSmart(row.entryPrice) : "-",
    },
    {
      name: "Live Price",
      selector: (row) => {
        const price = livePrices?.[row.symbol] || row.exitPrice;
        return price !== null ? (
          roundSmart(price) || (
            <div
              className="spinner-border spinner-border-sm text-success"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )
        ) : (
          <div
            className="spinner-border spinner-border-sm text-success"
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        );
      },
      sortable: true,
      width: "130px",
    },
    {
      name: "User Name",
      selector: (row) =>
        row.userInfo?.UserName ? row.userInfo?.UserName : "Admin",
      sortable: true,
      width: "140px",
      cell: (row) => <>{row.userInfo?.UserName}</>,
    },
    {
      name: "P/L",
      selector: (row) => {
        const livePrice = livePrices?.[row.symbol];
        const entryPrice = parseFloat(row.entryPrice);
        const quantity = parseFloat(quantityM);

        if (!livePrice || !entryPrice || !quantity) return "-";

        let pnl = 0;
        if (row.side === "BUY") {
          pnl = (livePrice - entryPrice) * quantity;
        } else if (row.side === "SELL") {
          pnl = (entryPrice - livePrice) * quantity;
        }

        return roundSmart(pnl);
      },
      cell: (row) => {
        const livePrice = livePrices?.[row.symbol];
        const entryPrice = parseFloat(row.entryPrice);
        const quantity = parseFloat(quantityM);

        if (!livePrice || !entryPrice || !quantity)
          return <span style={{ color: "gray" }}>-</span>;

        let pnl = 0;
        if (row.side === "BUY") {
          pnl = (livePrice - entryPrice) * quantity;
        } else if (row.side === "SELL") {
          pnl = (entryPrice - livePrice) * quantity;
        }

        const pnlColor = pnl >= 0 ? "green" : "red";

        return (
          <span style={{ color: pnlColor }}>{pnl ? roundSmart(pnl) : "0"}</span>
        );
      },
      sortable: true,
      width: "100px",
    },
    {
      name: "Target",
      selector: (row) => row.target,
      cell: (row) => (
        <input
          type="number"
          name="target"
          value={getFieldValue(row, "target") || ""}
          onChange={(e) => handleOnChange(row, e)}
          className={getInputClassName(row, "target")}
          placeholder="Target"
          disabled={!editableRows[row._id]}
        />
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Stop Loss",
      selector: (row) => row.stoploss,
      cell: (row) => (
        <input
          type="number"
          name="stoploss"
          value={getFieldValue(row, "stoploss") || ""}
          onChange={(e) => handleOnChange(row, e)}
          className={getInputClassName(row, "stoploss")}
          placeholder="Stop Loss"
          step="0.01"
          disabled={!editableRows[row._id]}
        />
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      cell: (row) => {
        if (row.signalType !== "ADMIN") return null; // show only for ADMIN

        const isEditable = editableRows[row._id];

        return (
          <div className="d-flex gap-2">
            {isEditable ? (
              <>
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => handleUpdateRow(row)}
                >
                  Confirm
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() =>
                    setEditableRows((prev) => ({ ...prev, [row._id]: false }))
                  }
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                  setEditableRows((prev) => ({ ...prev, [row._id]: true }))
                }
                disabled={row.extstatus !== "ACTIVE"}
              >
                Edit
              </button>
            )}
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "160px", // increased width to fit 2 buttons
    },
    {
      name: "Details View",
      cell: (row) => (
        <Eye
          className="mx-2"
          onClick={() => {
            setRowData(row);
            setshowModal(true);
          }}
          style={{ cursor: "pointer" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    },
    {
      name: "Square Off",
      cell: (row) => (
        <>
          {row.signalType == "ADMIN" && (
            <button
              className="btn btn-outline-danger btn-sm"
              disabled={row.extstatus !== "ACTIVE"}
              onClick={() => {
                Swal.fire({
                  title: "Are you sure?",
                  text: "You want to square off this trade!",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes, square off it!",
                }).then((result) => {
                  if (result.isConfirmed) {
                    handleSquareOff(row);
                  }
                });
              }}
              style={{
                opacity: row.extstatus === "ACTIVE" ? 1 : 0.5,
                cursor: row.extstatus === "ACTIVE" ? "pointer" : "not-allowed",
                fontWeight: "bold",
                borderRadius: "4px",
                padding: "2px 10px",
                minWidth: "90px",
              }}
              title={
                row.extstatus !== "ACTIVE"
                  ? "Trade already closed"
                  : "Square Off this trade"
              }
            >
              Square Off
            </button>
          )}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "130px",
    },
  ];

  const handleSquareOff = async (row) => {
    if (row.extstatus !== "ACTIVE") return;

    try {
      const data = `symbol:${row.symbol}|ordertype:${row.side === "BUY" ? "SELL" : "BUY"
        }|quantity:100|price:${livePrices[row.symbol]}|strategy:${row?.strategy
        }|key:${row.key}|category:${row.category
        }|signalType:SQUARE_OFF|tradeid:${row._id}`;

      const response = await TRADE_EXECUTE(data);

      if (response.status) {
        toast.success(response.message);
        fetchTradeHistory();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error in square off:", error);
      toast.error("Failed to square off trade");
    }
  };

  const handleChange = (date) => {
    // 👇 return karega format YYYY-MM-DD
    const formatted = format(date, "yyyy-MM-dd");
    return formatted;
  };

  return (
    <Content
      Page_title="Open Position"
      button_status={false}
      button_status1={true}
    >
      <div className="filter-row row gx-3 gy-2 align-items-end mb-3">

        <div className="col-md-2">
          <label className="form-label mb-1">From Date</label>
          <DatePicker
            selected={fromDate ? new Date(fromDate) : null}
            onChange={(date) => setFromDate(handleChange(date))}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select date"
            className="form-control"
          />
        </div>

        <div className="col-md-2">
          <label className="form-label mb-1">To Date</label>
          <DatePicker
            selected={toDate ? new Date(toDate) : null}
            onChange={(date) => setToDate(handleChange(date))}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select date"
            className="form-control"
            minDate={fromDate ? new Date(fromDate) : null}
          />
        </div>

        <div className="col-md-2">
          <label className="form-label mb-1">Strategy</label>
          <select
            value={strategy}
            onChange={(e) => setStrategy(e.target.value)}
            className="form-control"
          >
            <option value="">All Strategies</option>
            {availableStrategies.map((strategyOption, index) => (
              <option key={index} value={strategyOption}>
                {strategyOption}
              </option>
            ))}
          </select>
        </div>

        {/* <div className="col-md-2">
          <label className="form-label mb-1 fw-semibold">Quantity</label>
          <input
            type="number"
            className="form-control"
            value={quantityM}
            onChange={(e) => {
              if (e.target.value < 0) {
                setQuantity(1);
              } else {
                setQuantity(e.target.value);
              }
            }}
          />
        </div> */}
        <div className="col-md-3">
          <label className="form-label mb-1">Search</label>
          <input
            type="text"
            placeholder="Search by Symbol or Strategy"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control"
          />
        </div>

        <div className="col-md-2">
          <label className="form-label mb-1">Filter by Username</label>
          <select
            className="form-control"
            value={selectedUsername}
            onChange={(e) => setSelectedUsername(e.target.value)}
          >
            <option value="">All Users</option>
            {[...new Set(
              tradeHistoryData
                .map((item) => item.userInfo?.UserName)
                .filter(Boolean)
            )].map((name, index) => (
              <option key={index} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>


        <div className="col-md-1 d-flex">
          <button
            className="btn btn-sm btn-primary mt-auto"
            onClick={() => {
              setRefresh((prev) => !prev);
              refresbtn();
            }}
          >
            <i className="fa fa-refresh"></i>
          </button>
        </div>

      </div>


      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <Table columns={columns} data={filteredTradeData} waterMark={true} />
        </div>
      )}

      <DetailsView
        showModal={showModal}
        setshowModal={() => setshowModal(false)}
        tradeHistoryData={rowData}
      />
    </Content>
  );
};

export default Tradinghistory;
